<div class="wrapper mb-5">
    <app-grupo-create-timeline [step]="step"></app-grupo-create-timeline>
    <div class="alert alert-light my-4" role="alert">
        <h4 class="alert-heading">Vamos começar?</h4>
        <p>A ideia do grupo é oferecer uma cesta de benefícios.
            Primeiro vamos determinar o nome do grupo, e posteriormente, dentro deste novo grupo vamos adicionar quais os produtos que vão fazer parte desta nova cesta de benefícios.
            Iremos determinar a quantia e periodicidade que você irá distribuir no saldo flexível "saldo livre" e qual quantia você irá distribuir nos demais saldo de produtos destinados para uso em segmentos específicos. </p>
    </div>
    <form [formGroup]="form" class="form-card mt-2">
        <label for="group-name">Nome do grupo*</label>
        <input [ngClass]="isFormValid ? '' : 'invalid'" formControlName="name" type="text" id="group-name" placeholder="Nome do grupo">
        <span *ngIf="!isFormValid" class="hint mt-2 red">O nome é obrigatório!</span>
        <span class="hint mt-2">Exemplo: Gerência, Supervisores, Estagiários...</span>
        <label class="mt-4" for="group-description">Descrição</label>
        <input formControlName="description" type="text" id="group-description" placeholder="Descrição">
        <button (click)="next()" class="action-button mt-5">Próximo</button>
    </form>
</div>
